<template>
  <div>
    <div class="row">
      <div class="col-5 text-center"><h3 class="mt-0">Plan</h3></div>
      <div class="col-2"></div>
      <div class="col-5 text-center"><h3 class="mt-0">Complete</h3></div>
    </div>
    <draggable group="row" v-model="cards" draggable=".plan-complete-row" :disabled="previewMode" ghost-class="bg-light" @end="updateCardPositions">
      <div v-for="(card, index) in cards" :key="`schedule_card${card.card_id}_${index}`"  class="row plan-complete-row align-items-center mb-3 py-2 rounded" :class="{previewing: previewMode}">
        <div class="col-5">
          <draggable v-if="!cardFinished(card)" :sort="false" :group="{ name: `card_group${card.id}`, pull: 'clone', put: false }" @end="addToCompleted(card)">
            <Card :card="card" :selected="false" />
          </draggable>
          <div v-else class="card bg-light w-100 h-100 pointer card-holder" @click="removeFromCompleted(card)">
            <b-icon icon="arrow-counterclockwise" style="height: 100%; width: 50%; margin: auto" variant="secondary"></b-icon>
          </div>
        </div>
        <div class="col-2 align-self-center text-center plan-complete-icon">
          <b-icon icon="arrow-right" style="width: 100%; height: auto"></b-icon>
          <b-icon v-if="!previewMode" icon="arrows-move" style="width: 100%; height: auto"></b-icon>
        </div>
        <div class="col-5">
          <draggable v-if="cardFinished(card)" :sort="false" :group="{ name: `card_group${card.id}`, pull: 'clone', put: false }" @end="removeFromCompleted(card)">
            <Card :card="card" :selected="false" />
          </draggable>
          <div v-else class="card bg-light w-100 h-100 pointer card-holder" @click="addToCompleted(card)">
            <b-icon icon="check2" style="height: 100%; width: 50%; margin: auto" variant="secondary"></b-icon>
          </div>
        </div>
      </div>
    </draggable>
    <div class="row non-share" v-if="completedCards.length">
      <div class="col-5"></div>
      <div class="col-2"></div>
      <div class="col-5">
        <b-button variant="secondary" size="sm" @click="restart">
          <b-icon icon="arrow-counterclockwise"></b-icon> Restart</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState, mapGetters, mapActions, mapMutations,
} from 'vuex';
import draggable from 'vuedraggable';
import Card from '../Card.vue';

export default {
  components: {
    Card, draggable,
  },

  props: {
    previewMode: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      completedCards: [],
    };
  },

  watch: {
    completedCards() {
      this.updateVisualScheduleContent(true);
    },
  },

  computed: {
    ...mapState(['visualSchedule']),
    ...mapGetters(['scheduleCards']),

    cards: {
      get() {
        return this.scheduleCards;
      },
      set(val) {
        this.updateVisualSchedule({ field: 'visual_schedule_cards_attributes', value: val });
      },
    },

    displayId() {
      return this.visualSchedule.visual_schedule_display_id;
    },
  },

  methods: {
    ...mapMutations(['updateVisualSchedule', 'updateVisualScheduleContent']),
    ...mapActions(['updateCardPositions']),

    addToCompleted(card) {
      this.completedCards.push(card);
    },

    removeFromCompleted(card) {
      const index = this.completedCards.findIndex((c) => c.card_id === card.card_id);
      if (index !== -1) this.completedCards.splice(index, 1);
    },

    cardFinished(card) {
      return this.completedCards.find((c) => c.card_id === card.card_id && card.position === c.position);
    },

    restart() {
      this.completedCards = [];
    },
  },
};
</script>
